import { ApplicationMilestone, TicketAttributes, TicketPriority, TicketStatus, TicketStatusEmoji } from '@copetence/shared';
import Modal from 'components/modal/Modal.comp';
import { classes } from 'handlers/StyleHandler';
import { useAppContext } from 'providers/ContextProvider';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import s from './listTickets.module.scss';
import { useListTicketsState } from './ListTicketsState';

const ListTickets = () => {

  const state = useListTicketsState();
  const [viewingTicket, setViewingTicket] = useState<TicketAttributes | null>(null);
  const { t } = useTranslation();

  const { appId } = useAppContext();

  useEffect(() => {
    state.sync(appId);
  }, [appId]);

  return (
    <div className={s.listTickets}>
      {state.milestones.map((milestone) =>
        <Milestone
          key={milestone.id}
          milestone={milestone}
          setViewingTicket={setViewingTicket}
        />
      )}

      {/* Ticket Viewer Modal */}
      <Modal
        open={!!viewingTicket}
        onClose={() => setViewingTicket(null)}
        title={t('tickets.inspectTicket')}
      >
        {viewingTicket ?
          <div className={s.ticketViewer}>
            <div>
              <p className={s.label}>{t('tickets.issueDescription')}</p>
              <p>{viewingTicket.issueDescription}</p>
            </div>
            <div>
              <p className={s.label}>{t('tickets.priority')}</p>
              {viewingTicket.priority === TicketPriority.URGENT && <p>❗ {t('tickets.priorityUrgent', 'Urgent')}</p>}
              {viewingTicket.priority === TicketPriority.HIGH && <p>🔴 High</p>}
              {viewingTicket.priority === TicketPriority.MEDIUM && <p>🟡 Medium</p>}
              {viewingTicket.priority === TicketPriority.LOW && <p>🟢 Low</p>}
            </div>
            <div>
              <p className={s.label}>{t('tickets.milestoneTitle')}</p>
              <p>{viewingTicket.milestoneId}</p>
            </div>
          </div>
          :
          <p>{t('tickets.noTicketSelected')}</p>
        }
      </Modal>
    </div>
  )
}

const Milestone = ({
  milestone,
  setViewingTicket
}: {
  milestone: ApplicationMilestone,
  setViewingTicket: React.Dispatch<React.SetStateAction<TicketAttributes | null>>
}) => {
  const state = useListTicketsState();
  const tickets = state.tickets.filter(ticket => ticket.milestoneId === milestone.id)
  const [isHidden, setIsHidden] = useState<boolean>(false)

  if (!tickets.length) return null;

  return (
    <div className={classes(s.milestone, isHidden ? s.hidden : "")}>
      <div className={s.titlebar} onClick={() => setIsHidden(!isHidden)}>
        <p>{milestone.name}</p>
      </div>
      <div className={s.tickets}>
        {Object.keys(TicketStatus).map((statusKey) => {
          const status = TicketStatus[statusKey as keyof typeof TicketStatus]
          const ticketsInStatus = tickets.filter(ticket => ticket.status === status)

          if (!ticketsInStatus.length) return null;

          return (
            <div className={s.status} key={status}>
              <div className={s.statusTitle}>
                {TicketStatusEmoji(status)} {status.replaceAll("_", " ")}
              </div>
              <div className={s.ticketList}>
                {ticketsInStatus.map((ticket) =>
                  <div
                    className={s.ticket}
                    key={ticket.id}
                    onClick={() => setViewingTicket(ticket)}
                  >
                    {ticket.issueDescription}
                  </div>
                )}
              </div>
            </div>
          )

        })}
      </div>
    </div>
  )
}




export default ListTickets;